module.exports = __webpack_public_path__ + "img/corn.15547d6c.svg";